import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../client.js";

import Loading from "../components/global/Loading";
import MixSlide from "../components/Home/MixSlide";
import Pagination from "../components/Home/Pagination";
import Dots from "../components/Home/Dots";
import MetaCircle from "../components/Home/MetaCircle";
import Background from "../components/Home/Background";
import Tab from "../components/Home/Tab";
import ElSlide from "../components/Home/ElSlide";

const Home = (props) => {
  const {
    isMobile,
    sanityData,
    mixesData,
    currentPage,
    setCurrentPage,
    setDrawerMix,
    setDrawerOpen,
    latestMixes,
    setPlayingMix,
    setPlayerOpen,
  } = props;

  useEffect(() => {
    if (currentPage !== "home") {
      setCurrentPage("home");
    }
  });

  const builder = imageUrlBuilder(sanityClient);
  function urlFor(source) {
    return builder.image(source);
  }

  // const [sortedLatestMixes, setSortedLatestMixes] = useState(null);

  // useEffect(() => {
  //   const sortedByDate = [...latestMixes].sort((a, b) =>
  //     b.releaseDate?.localeCompare(a.releaseDate)
  //   );

  //   setSortedLatestMixes(sortedByDate);
  // }, [latestMixes]);

  const [activeIndex, setActiveIndex] = useState(0);

  if (sanityData.carousel && sanityData.carousel.mixes && mixesData) {
    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, transition: { duration: 0.4 } }}
        key={"home-wrapper"}
        className="home__wrapper"
      >
        <Pagination
          {...{ activeIndex, setActiveIndex }}
          mixes={sanityData.carousel.mixes}
        />
        <Dots {...{ isMobile, activeIndex }} mixes={sanityData.carousel.mixes}/>
        <MetaCircle {...{ activeIndex }} mixes={sanityData.carousel.mixes}/>
        {/* 
        <Dots {...{ isMobile, sortedLatestMixes, activeIndex }} />
        <MetaCircle {...{ sortedLatestMixes, activeIndex }} /> */}
        {/* <MysterySlide {...{ activeIndex }} /> */}
        {/* <MysteryTab {...{ activeIndex }} /> */}

        {/* <div
          className={`home__background-wrapper home__mystery-bkg ${
            activeIndex === 0 ? "active" : ""
          }`}
        ></div> */}

        {sanityData.carousel.mixes.map((mix, index) => {
          if (mix._type === "mix") {
            const image = `${urlFor(mix.cover)}`;
            
            // console.log(mix);
            
            
            return (
              <>
                <Background
                  {...{ mix, index, activeIndex, image }}
                  key={`bkg${index}`}
                />
                <MixSlide
                  {...{
                    mix,
                    image,
                    index,
                    mixesData,
                    latestMixes,
                    activeIndex,
                    setDrawerMix,
                    setDrawerOpen,
                    setPlayingMix,
                    setPlayerOpen,
                  }}
                  key={`slide${index}`}
                />
                <Tab {...{ mix, index, activeIndex }} key={`tab${index}`} />
              </>
            );
          } else if (mix._type === "editorsLetter") {
            return (
              <>
                <Background
                  {...{ mix, index, activeIndex }}
                  key={`bkg${index}`}
                />
                <ElSlide
                  {...{
                    mix,
                    index,
                    activeIndex,
                  }}
                  key={`slide${index}`}
                />
              </>
            );
          }
        })}

        {/* {sortedLatestMixes.map((mix, index) => {
          return (
            <>
              <Background
                {...{ mix, index, activeIndex }}
                key={`bkg${index}`}
              />
              <MixSlide
                {...{
                  mix,
                  index,
                  activeIndex,
                  setDrawerMix,
                  setDrawerOpen,
                  setPlayingMix,
                  setPlayerOpen,
                }}
                key={index}
              />
              <Tab {...{ mix, index, activeIndex }} key={`tab${index}`} />
            </>
          );
        })} */}
      </motion.main>
    );
  } else {
    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, transition: { duration: 0.4 } }}
        key={"archive-wrapper"}
        className="ra__fp-loading"
      >
        <Loading />
      </motion.main>
    );
  }
};

export default Home;
